import React, { useEffect, useMemo, useState } from "react";
import { Trash2 } from "lucide-react";

const PopupContent = ({
  bills,
  user,
  handleDelete,
  filterOptions,
  companies,
  handleSearch,
  firstOpen,
  setFirstOpen,
}) => {
  const [selectedUser, setSelectedUser] = useState("all");
  const [selectedCompany, setSelectedCompany] = useState("all");
  const [inputValue, setInputValue] = useState("");
  const [filteredBills, setFilteredBills] = useState([]);
  const [firstFilter, setFirstFilter] = useState(true);

  const billsArray = useMemo(() => {
    return Array.isArray(bills) ? bills : bills ? [bills] : [];
  }, [bills]);

  useEffect(() => {
    let filtered = billsArray;

    if (user?.privilege === "master") {
      if (selectedUser !== "all") {
        filtered = filtered.filter(
          (invoice) => invoice?.user === selectedUser
        );
      }

      if (inputValue !== "" && selectedUser === "all") {
        filtered = filtered.filter(
          (invoice) => invoice?.Bill_ID === inputValue
        );
      }

      if (selectedCompany !== "all") {
        filtered = filtered.filter(
          (invoice) => invoice?.locationName === selectedCompany
        );
      }
    }

    setFilteredBills(filtered);
  }, [
    selectedUser,
    selectedCompany,
    inputValue,
    billsArray,
    user?.privilege,
  ]);

  const currentDate = new Date();

  const distinctUsers =
    billsArray.length > 0
      ? Array.from(new Set(billsArray.map((invoice) => invoice?.user))).filter(
          Boolean
        )
      : [];

  const handleChangeUser = (selectedValue) => {
    setSelectedUser(selectedValue);

    if (firstFilter) {
      setFirstFilter(false);
    }
  };

  const handleSelect = (company) => {
    setSelectedCompany(company);

    if (firstFilter) {
      setFirstFilter(false);
    }
  };

  const handleKeyUp = (e) => {
    if (e.key === "Enter") {
      handleSearch(inputValue);
    }

    if (setFirstOpen) {
      setFirstOpen(false);
    }
  };

  const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
  };

  const cellStyle = {
    padding: "8px",
    textAlign: "left",
    border: "1px solid #dddddd",
    minWidth: "100px",
  };

  const actionStyle = {
    cursor: "pointer",
  };

  const headerStyle = {
    ...cellStyle,
    backgroundColor: "#343a40",
    color: "white",
  };

  const colorWarning = {
    color: "red",
  };

  return (
    <div>
      <h1>Facturas cargadas</h1>

      <p>
        Fecha:{" "}
        {filterOptions?.startDate
          ? filterOptions?.endDate
            ? `${filterOptions?.startDate} - ${filterOptions?.endDate}`
            : filterOptions?.startDate
          : currentDate.toLocaleDateString()}
      </p>

      {user?.privilege !== "master" ? (
        <p>Cargadas por el usuario: {user?.user}</p>
      ) : (
        <>
          <label>
            Filtrar por usuario:
            <select
              value={selectedUser}
              onChange={(e) => handleChangeUser(e.target.value)}
            >
              <option value="all">Seleccionar usuario</option>

              {distinctUsers.map((userName) => (
                <option key={userName} value={userName}>
                  {userName}
                </option>
              ))}
            </select>
          </label>

          <label>
            Filtrar por ID de factura:
            <input
              placeholder="Ingrese ID de factura"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              onKeyUp={handleKeyUp}
            />
          </label>

          <label>
            Filtrar por sucursal:
            <select
              value={selectedCompany}
              onChange={(e) => handleSelect(e.target.value)}
            >
              <option value="all">Seleccionar sucursal</option>

              {companies?.length > 0 &&
                companies.map((c) => (
                  <option key={c.id_company || c.id || c.name} value={c.name}>
                    {c.name}
                  </option>
                ))}
            </select>
          </label>
        </>
      )}

      {filteredBills.length === 0 ? (
        <p style={colorWarning}>No se encuentran facturas cargadas.</p>
      ) : null}

      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={headerStyle}>Sucursal</th>
            <th style={headerStyle}>Utilidad</th>
            <th style={headerStyle}>Proveedor</th>
            <th style={headerStyle}>Nro cuenta</th>
            <th style={headerStyle}>ID factura</th>
            <th style={headerStyle}>Emisión</th>
            <th style={headerStyle}>Lectura actual</th>
            <th style={headerStyle}>Lectura anterior</th>
            <th style={headerStyle}>Vencimiento</th>
            <th style={headerStyle}>Consumo</th>
            <th style={headerStyle}>Costo</th>
            <th style={headerStyle}>User</th>
            <th style={headerStyle}>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {!firstFilter ||
          filteredBills.length === 1 ||
          (!firstOpen && filteredBills.length > 0)
            ? filteredBills.map((invoice, index) => (
                <tr key={`${invoice?.id || invoice?.Bill_ID}-${index}`}>
                  <td style={cellStyle}>{invoice?.locationName}</td>
                  <td style={cellStyle}>{invoice?.utilityType}</td>
                  <td style={cellStyle}>{invoice?.supplier}</td>
                  <td style={cellStyle}>{invoice?.AccountNumber}</td>
                  <td style={cellStyle}>{invoice?.Bill_ID}</td>
                  <td style={cellStyle}>{invoice?.invoiceDate}</td>
                  <td style={cellStyle}>{invoice?.readingDate}</td>
                  <td style={cellStyle}>{invoice?.previousDate}</td>
                  <td style={cellStyle}>{invoice?.dueDate}</td>

                  <td style={cellStyle}>
                    {invoice?.consumption === "-1" ||
                    invoice?.consumption === null ||
                    invoice?.consumption === undefined ||
                    isNaN(Number(invoice?.consumption))
                      ? "N/A"
                      : `${Number(invoice?.consumption).toFixed(2)} kWh`}
                  </td>

                  <td style={cellStyle}>
                    {invoice?.cost === "-1" ||
                    invoice?.cost === null ||
                    invoice?.cost === undefined ||
                    isNaN(Number(invoice?.cost))
                      ? "N/A"
                      : `AR$ ${Number(invoice?.cost).toFixed(2)}`}
                  </td>

                  <td style={cellStyle}>{invoice?.user}</td>

                  <td style={cellStyle}>
                    <Trash2
                      size={18}
                      style={actionStyle}
                      onClick={(e) => handleDelete(e, invoice?.Bill_ID)}
                    />
                  </td>
                </tr>
              ))
            : null}
        </tbody>
      </table>
    </div>
  );
};

export default PopupContent;